/**
 * Created by olga on 12.12.2025
 */

Placements.ENTRIES["weeklyGoals"] = {
    throttled: true,

    type: Placements.FREE_FOCUS,
    filter: function () {
        return cleverapps.environment.isMainScene() && cleverapps.meta.getSelectedLocation().locationConfig.isMain && cleverapps.weeklyGoals.needShowStartWindow;
    },

    action: function () {
        cleverapps.weeklyGoals.displayWindow();
        cleverapps.weeklyGoals.needShowStartWindow = false;
    }
};
